<template>
<div class="table-responsive">
    <table :class="renderTableClass">
        <thead class="thead-dark">
            <tr v-if="elements && type === 'view'">
                <th v-for="(head, headIndex) in elements" :key="headIndex">{{ head.title }}</th>
            </tr>
            <tr v-if="elements && type === 'input'">
                <th><button @click="addRow" type="button" class="btn btn-outline-light btn-sm rounded-circle"><i class="fas fa-plus"></i></button></th>
                <th v-for="(head, headIndex) in elements" :key="headIndex">{{ head.title }}</th>
            </tr>
        </thead>
        <tbody v-if="type === 'view'">
            <tr v-for="(data, rowIndex) in collections" :key="rowIndex" :class="styleSelectedRow(data.id)" @click="selectRow(data.id)">
                <td v-for="(element, colIndex) in elements" :key="colIndex" >
                    <div v-if="element.type !== 'link' && element.type !== 'upload'" :style="{ width: `${element.width*50}px` }">{{ (element.type === 'date') ? moment(data[element.column]).format('L') : (element.type === 'number') ? numeral(data[element.column]).format('0,0') : (element.type === 'currency') ? 'Rp ' + numeral(data[element.column]).format('0,0.00') : data[element.column] }}</div>
                    <app-uploader v-if="element.type === 'upload'" :style="{ width: `${element.width*50}px` }" :fileUrl="data[element.column]" :fieldName="element.column" @click="uploaderClicked(rowIndex)" v-on:finishUpload="finishUpload(rowIndex, ...arguments)"></app-uploader>
                    <div v-if="element.type === 'link' && data[element.column]"><a :href="data[element.column]" class="badge badge-primary">Your uploaded file</a></div>
                    <div v-if="element.type === 'link' && !data[element.column]"><a class="badge badge-dark" style="color: white;">No Attachment</a></div>
                    <button v-if="element.type === 'button-inline'" @click="buttonClicked(rowIndex)" type="button" class="btn btn-secondary btn-sm"> {{ element.text }}</button>
                </td>
            </tr>
        </tbody>
        <tbody v-if="type === 'input'">
            <tr v-for="(data, rowIndex) in collections" :key="rowIndex">
                <td><button @click="delRow(rowIndex)" type="button" class="btn btn-outline-dark btn-sm rounded-circle"><i class="fas fa-minus"></i></button></td>
                <td v-for="(element, colIndex) in elements" :key="colIndex" >
                    <app-uploader v-if="element.type === 'upload'" :fileUrl="data[element.column]" :fieldName="element.column" @click="uploaderClicked(rowIndex)" v-on:finishUpload="finishUpload(rowIndex, ...arguments)"></app-uploader>
                    <input v-if="element.type !== 'lookup' && element.type !== 'date' && element.type !== 'dropdown' && element.type !== 'upload' && element.type !== 'button-inline'" :disabled="element.disable" :style="{ width: `${element.width*50}px` }" :type="element.type" v-model="data[element.column]">
                    <flat-pickr style="background-color:white;" v-if="element.type === 'date'" class="form-control" v-model="data[element.column]"></flat-pickr>
                    <select v-if="element.type === 'dropdown'" class="form-control" :id="element.id" v-model="data[element.column]">
                        <option v-for="(list, index) in element.lists" :key="index" :value="list.value">{{ list.title }}</option>
                    </select>
                    <div :style="{ width: `${element.width*50}px` }">
                        <app-lookup-field v-if="element.type === 'lookup'" :rowIndex="rowIndex" :headerModel="headerModel" :model="data" :disable="true" :element="element.lookup" v-on:selectLookup="finishLookup" v-on:selectedRowIndex="selectRowModal"></app-lookup-field>
                    </div>
                    <button v-if="element.type === 'button-inline'" @click="buttonClicked(rowIndex)" type="button" class="btn btn-secondary btn-sm"> {{ element.text }}</button>
                </td>
            </tr>
        </tbody>
    </table>
</div>
</template>

<script>
import AppLookupField from './AppLookupField.vue'
import AppDatePicker from './AppDatePicker.vue'
import AppUploader from './AppUploader.vue'

export default {
    props: ['type', 'elements', 'headerModel', 'collections', 'newData'],
    components: {
        AppLookupField, AppDatePicker, AppUploader
    },
    data() {
        return {
            selectedId: 0,
            selectedRowDetailId: -1,
            uploaderIndex: -1
        }
    },
    computed: {
        renderTableClass() {
            return (this.type === 'view') ? 'table table-hover' : 'table table-borderless table-sm'
        }
    },
    methods: {
        selectRow(id) {
            this.selectedId = id
            this.$emit('selectedRow', id)
        },
        styleSelectedRow(id) {
            if(this.selectedId === id) {
                return 'table-success'
            }
        },
        addRow() {
            this.collections.splice(this.collections.length + 1, 0, { ...this.newData })
        },
        delRow(index) {
            this.collections.splice(index, 1)
        },
        finishLookup(data) {
            const currentData = this.collections[this.selectedRowDetailId]
            this.collections.splice(this.selectedRowDetailId, 1, {
                ...currentData,
                ...data
            })
        },
        selectRowModal(rowIndex) {
            this.selectedRowDetailId = rowIndex
        },
        finishUpload(index, data) {
            const currentData = this.collections[index]
            this.collections.splice(index, 1, {
                ...currentData,
                ...data
            })
        },
        buttonClicked(index) {
            this.$emit('buttonInlineClicked', index)
        }
    }
}
</script>

<style scoped>

</style>